import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=494ae7d7&scoped=true&"
import script from "./Center.vue?vue&type=script&lang=js&"
export * from "./Center.vue?vue&type=script&lang=js&"
import style1 from "./Center.vue?vue&type=style&index=1&id=494ae7d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ae7d7",
  null
  
)

export default component.exports